/**
 * Voice feature access logic.
 * 
 * Access = tenant.feature AND (user.features absent OR user.feature === true)
 * Premium includes Standard.
 */

export function hasVoiceAccess(user, tenant, feature = 'voice_standard') {
  const tenantFeatures = tenant?.features || {};
  const userFeatures = user?.features; // null/undefined = fallback to tenant-level

  // Tenant must have the feature enabled (premium includes standard)
  const tenantHasFeature = feature === 'voice_standard'
    ? (tenantFeatures.voice_standard === true || tenantFeatures.voice_clone === true)
    : tenantFeatures[feature] === true;

  if (!tenantHasFeature) return false;

  // If user.features is not set at all, fallback = granted (tenant-level applies)
  if (userFeatures === undefined || userFeatures === null) return true;

  // User-level check
  if (feature === 'voice_standard') {
    // Premium includes Standard
    return userFeatures.voice_standard === true || userFeatures.voice_clone === true;
  }

  return userFeatures[feature] === true;
}

export function hasVoiceStandard(user, tenant) {
  return hasVoiceAccess(user, tenant, 'voice_standard');
}

export function hasVoiceClone(user, tenant) {
  return hasVoiceAccess(user, tenant, 'voice_clone');
}
